import {API_URL, API_URL_STORY} from '../constants'
import { apiFetch } from './client';
import {setNotifications} from "../store/slices/notifications";


export const getAllAuthors = async (queryParams) => {
    console.log('queryParams',queryParams);
    const res = await apiFetch(`${API_URL_STORY}/authors?page=${queryParams.page}&limit=${queryParams.perPage}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getAuthorById = async (id) => {
    const res = await apiFetch(`${API_URL_STORY}/stories/${id}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

